/**
 * API CompagnonCPS
 * API pour le connecteur CompagnonCPS
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface CreationPrescriptionPatient { 
    /**
     * EF_EP04.03 Donnée fournie par le LPS et définissant la date de naissance du patient. Pour les dates estimées, renseigner 01/01/XX 01-01-XX avec XX l’année estimée.
     */
    DateNai: string;
    /**
     * EF_EP404.04 Donnée fournie par le LPS et définissant le poids du patient en kilogrammes.
     */
    Poids?: number;
    /**
     * EF_EP04.02 Donnée fournie par le LPS et définissant le prénom du patient à insérer dans le code 2D. Pour EF_EP04.02, ajout d’espaces (6) à la fin du nom prénom pour obtenir une donnée de 100 caractères exactement (4) . Pour EF_EP_404.02, maximum.
     */
    Prenom: string;
    /**
     * EF_EP404.05 Donnée fournie par la LPS et définissant la taille du patient en centimètres.
     */
    Taille?: number;
}

